import React from 'react'
import LoadingOverlaySpinner from './LoadingOverlaySpinner'

function LoadingOverlay({
  loading,
  children,
  minHeight = '50vh',
}: { loading: boolean; children: React.ReactNode; minHeight?: string }) {
  return (
    <div className="overlay-container" style={{ minHeight }}>
      <div aria-busy={loading} aria-live="polite">
        {children}
      </div>
      {loading && (
        <div
          className="overlay-container--backdrop"
          role="presentation"
          aria-hidden="true"
        >
          <LoadingOverlaySpinner />
        </div>
      )}
    </div>
  )
}

LoadingOverlay.defaultProps = {
  minHeight: '50vh',
}

export default LoadingOverlay
